import { render, staticRenderFns } from "./SoldierReport.vue?vue&type=template&id=0a9cc3e2"
import script from "./SoldierReport.vue?vue&type=script&lang=js"
export * from "./SoldierReport.vue?vue&type=script&lang=js"
import style0 from "./SoldierReport.vue?vue&type=style&index=0&id=0a9cc3e2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports